<nav class="fixed bottom-0 left-0 right-0 bg-[var(--pax-bottom-navigation-background)] shadow-lg h-[104px] pt-4 pb-8 px-6 z-50">
    <div class="flex gap-6 justify-around items-center h-full">
        @for (item of mainNavigationItems; track item.path) {
            <a [routerLink]="[item.path]" class="flex flex-col justify-center items-center w-full text-[var(--pax-bottom-navigation-text-color)] transition-colors">
                <lucide-icon
                    #link="routerLinkActive"
                    routerLinkActive
                    [style.color]="link.isActive ? 'var(--pax-bottom-navigation-text-color-active)' : 'var(--pax-bottom-navigation-text-color)'"
                    [name]="item.icon"
                    size="24"
                />
                <span
                    class="mt-1 text-xs text-center"
                    [style.color]="link.isActive ? 'var(--pax-bottom-navigation-text-color-active)' : 'var(--pax-bottom-navigation-text-color)'"
                    >{{ item.label }}</span
                >
            </a>
        }
        <button (click)="toggleMenu()" class="flex flex-col justify-center items-center w-full text-[var(--pax-bottom-navigation-text-color)] transition-colors">
            <lucide-icon
                [style.color]="isMenuOpen ? 'var(--pax-bottom-navigation-text-color-active)' : 'var(--pax-bottom-navigation-text-color)'"
                name="menu"
                size="24"
            />
            <span class="mt-1 text-xs text-center">{{ moreLabel() }}</span>
        </button>
    </div>
</nav>

<pax-fullscreen-menu
    [isOpen]="isMenuOpen"
    [navigationItems]="moreNavigationItems"
    [availableLanguages]="availableLanguages()"
    [currentLang]="currentLang()"
    (languageChange)="languageChange.emit($event)"
    (closeMenu)="isMenuOpen = false"
/>
